import assets from "app/assets";
import config from "config";
import { Container, Sprite } from "pixi.js";
import tools, { isMobileOS } from "tools";
import BoosterBtn from "./boosterBtn";
import gsap from "gsap";
const BTN_DECAL = 20;
export default class BoosterMenu extends Container {
  constructor() {
    super();
    tools.autobind(this);
    this.footerP = new Sprite(assets.textures.footerP.texture);
    this.footerP.anchor.set(0.5, 0.5);
    this.addChild(this.footerP);
    this.bomb = new BoosterBtn(assets.textures.bombBoost.texture, "bomb", 0);
    this.bomb.on("onClick", this._onClick);
    this.addChild(this.bomb);
    this.rocket = new BoosterBtn(assets.textures.rocketBoost.texture, "rocket", 1);
    this.rocket.on("onClick", this._onClick);
    this.addChild(this.rocket);
    this.swap = new BoosterBtn(assets.textures.swapBoost.texture, "swap", 2);
    this.swap.on("onClick", this._onClick);
    this.addChild(this.swap);
    this.hammer = new BoosterBtn(assets.textures.hammer.texture, "Hammer", 3);
    this.hammer.on("onClick", this._onClick);
    this.addChild(this.hammer);
  }
  _onClick(event) {
    switch (event.type) {
      case "bomb":
        config.bombBoosterReady = true;
        config.boosterPopin.show(assets.textures.bombBoost.texture, assets.local.bombBoosterText, null, null, true, null, true);
        this.bombTimer && this.bombTimer.kill();
        this.bombTimer = gsap.delayedCall(2, () => {
          config.boosterPopin.hide(false);
        });
        break;
      case "rocket":
        config.roketBoosterReady = true;
        config.boosterPopin.show(assets.textures.rocketBoost.texture, assets.local.rocketBoosterText, null, null, true, null, true);
        this.rocketTimer && this.rocketTimer.kill();
        this.rocketTimer = gsap.delayedCall(2, () => {
          config.boosterPopin.hide(false);
        });
        break;
      case "swap":
        config.swapBoosterReady = true;
        config.boosterPopin.show(assets.textures.swapBoost.texture, assets.local.swapBoosterText, null, null, true, null, true);
        this.swapTimer && this.swapTimer.kill();
        this.swapTimer = gsap.delayedCall(2, () => {
          config.boosterPopin.hide(false);
        });
        break;
      case "Hammer":
        config.hammerBoosterReady = true;
        config.boosterPopin.show(assets.textures.hammer.texture, assets.local.hammerBoosterText, null, null, true, null, true);
        this.hammerTimer && this.hammerTimer.kill();
        this.hammerTimer = gsap.delayedCall(2, () => {
          config.boosterPopin.hide(false);
        });
        break;
      default:
        break;
    }
  }
  set bombVal(val) {
    this.bomb.counter = val;
  }
  get bombVal() {
    return this.bomb.counter;
  }
  set hammerVal(val) {
    this.hammer.counter = val;
  }
  get hammerVal() {
    return this.hammer.counter;
  }
  set hammerCoinsVal(val) {
    this.hammer.coins = val;
  }
  get hammerCoinsVal() {
    return this.hammer.coins;
  }
  set bombCoinsVal(val) {
    this.bomb.coins = val;
  }
  get bombCoinsVal() {
    return this.bomb.coins;
  }
  set rocketVal(val) {
    this.rocket.counter = val;
  }
  get rocketVal() {
    return this.rocket.counter;
  }
  set rocketCoinsVal(val) {
    this.rocket.coins = val;
  }
  get rocketCoinsVal() {
    return this.rocket.coins;
  }
  set swapVal(val) {
    this.swap.counter = val;
  }
  get swapVal() {
    return this.swap.counter;
  }
  set swapCoinsVal(val) {
    this.swap.coins = val;
  }
  get swapCoinsVal() {
    return this.swap.coins;
  }
  set enable(val) {
    if (val) {
      this.bomb.tint = 0xffffff;
      this.rocket.tint = 0xffffff;
      this.swap.tint = 0xffffff;
      this.hammer.tint = 0xffffff;
    } else {
      this.bomb.tint = 0x777777;
      this.rocket.tint = 0x777777;
      this.swap.tint = 0x777777;
      this.hammer.tint = 0x777777;
    }
    !this.bomb.lock && (this.bomb.interactive = val);
    !this.rocket.lock && (this.rocket.interactive = val);
    !this.swap.lock && (this.swap.interactive = val);
    !this.hammer.lock && (this.hammer.interactive = val);
  }
  set progressLevelMode(val) {
    if (val) {
      // this.bomb.x = -100 * 2 + BTN_DECAL;
      this.bomb.lock = true;

      // this.rocket.x = this.bomb.x + 100 + BTN_DECAL;
      this.rocket.lock = true;

      // this.swap.x = this.rocket.x + 100 + BTN_DECAL;
      this.swap.lock = true;

      // this.hammer.x = this.swap.x + 100 + BTN_DECAL;
      this.hammer.lock = true;
    }
  }
  updateView(paysage) {
    if (!paysage) {
      this.footerP.angle = 0;
      this.footerP.scale.set(window.innerWidth * 0.8 / this.footerP.texture.width);
      this.footerP.position.set(window.innerWidth * 0.5, window.innerHeight - this.footerP.height * 0.8);
      let scree_cof = window.innerHeight / window.innerWidth;
      //correction for Ipad screen
      if (scree_cof < 1.4) {
        this.footerP.y = window.innerHeight * 0.91;
      }
      //correction for iphone pro
      if (scree_cof > 1.8) {
        this.footerP.y = window.innerHeight * 0.80;
      }
      this.maxScale = window.innerWidth / 768;
      if (this.maxScale > 0.8) {
        this.maxScale = 0.8;
      }
      let initX = this.footerP.x - this.footerP.width * 0.625;
      this.bomb.setMaxScale(this.maxScale);
      this.rocket.setMaxScale(this.maxScale);
      this.swap.setMaxScale(this.maxScale);
      this.hammer.setMaxScale(this.maxScale);
      this.bomb.position.set(initX + this.footerP.width * 1 / 4, this.footerP.y);
      this.rocket.position.set(initX + this.footerP.width * 2 / 4, this.footerP.y);
      this.swap.position.set(initX + this.footerP.width * 3 / 4, this.footerP.y);
      this.hammer.position.set(initX + this.footerP.width * 4 / 4, this.footerP.y);
    } else {
      let scree_cof = window.innerHeight / window.innerWidth;
      this.footerP.scale.set(window.innerHeight * 0.6 / this.footerP.texture.width);
      this.footerP.position.set(window.innerWidth * 0.12, window.innerHeight * 0.59);
      this.maxScale = 768 / window.innerWidth;
      if (scree_cof < 0.6) {
        //iphone
        this.maxScale = 0.33;
      }

      //desktop scale
      if (!isMobileOS()) {
        this.maxScale = 0.7;
      }
      if (this.maxScale > 0.8) {
        this.maxScale = 0.8;
      }
      this.footerP.angle = 90;
      let initY = this.footerP.y - this.footerP.width * 0.625;
      this.bomb.setMaxScale(this.maxScale);
      this.rocket.setMaxScale(this.maxScale);
      this.swap.setMaxScale(this.maxScale);
      this.hammer.setMaxScale(this.maxScale);
      this.bomb.position.set(this.footerP.x, initY + this.footerP.width * 1 / 4);
      this.rocket.position.set(this.footerP.x, initY + this.footerP.width * 2 / 4);
      this.swap.position.set(this.footerP.x, initY + this.footerP.width * 3 / 4);
      this.hammer.position.set(this.footerP.x, initY + this.footerP.width * 4 / 4);
    }
  }
  update() {
    if (config.MaxLevel >= assets.gameConfig.boosterLevelPalier[0]) {
      if (this.bomb.lock) {
        this.bomb.lock = false;
        this.bomb.counter == -1 && this.bomb.incCounter(1);
      }
    }
    if (config.MaxLevel >= assets.gameConfig.boosterLevelPalier[1]) {
      if (this.rocket.lock) {
        this.rocket.lock = false;
        this.rocket.counter == -1 && this.rocket.incCounter(1);
      }
    }
    if (config.MaxLevel >= assets.gameConfig.boosterLevelPalier[2]) {
      if (this.swap.lock) {
        this.swap.lock = false;
        this.swap.counter == -1 && this.swap.incCounter(1);
      }
    }
    if (config.MaxLevel >= assets.gameConfig.boosterLevelPalier[3]) {
      if (this.hammer.lock) {
        this.hammer.lock = false;
        this.hammer.counter == -1 && this.hammer.incCounter(1);
      }
    }
  }
}
